import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './AuthContext';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId="899599622269-6pdugadnn58lh6iet6sm2rplv94pgvvd.apps.googleusercontent.com">
            <AuthProvider>
                <App/>
        </AuthProvider>
        </GoogleOAuthProvider>
    </React.StrictMode>
);

reportWebVitals();
